import React from 'react';
import { Helmet } from 'react-helmet';
import { DropOffLocations } from '@return-rabbit/nexus';
import { useParams } from 'react-router-dom/cjs/react-router-dom';

import { If } from 'utils';
import { useQueryParams } from 'utils/hooks';
import { ThemeBlock, PoweredByBar } from 'components/Common';
import { LogoBanner } from '../QrShippingLabel/components';
import showPoweredByAspen from 'utils/methods/showPoweredByAspen';
import styles from './index.module.scss';

export default function DropoffLocations({
  storeName = '',
  isSSRStore = false
}) {
  const { os_id: osId } = useParams();
  const { getParam } = useQueryParams();
  const hasAspenBranding = showPoweredByAspen();

  const zipcode = getParam('zipcode');

  return (
    <>
      <If test={storeName}>
        <Helmet>
          <title>{storeName} Support | Drop-off Locations</title>
        </Helmet>
      </If>
      <div className={styles.dropoffLocations}>
        <LogoBanner />
        <DropOffLocations.Form
          title=""
          description=""
          osId={osId}
          defaultZipCode={zipcode}
          className={styles.dropoffLocations__form}
        />
        <If test={hasAspenBranding && !isSSRStore}>
          <ThemeBlock
            opacity={0.25}
            containerClassname={styles.poweredByFooterContainer}
            content={<PoweredByBar className="ml-0 mr-0" />}
          />
        </If>
      </div>
    </>
  );
}
